module.exports = __webpack_public_path__ + "media/images/bg_mv_selling_property-816812561e870c608826f4a219492450.jpg";